const VERSION_DATA_CENTER = "base-platform/v2"

// 获取消息中心数量
export const messageCenterNumber = {
    url: `/${VERSION_DATA_CENTER}/homepage/message/center/number`,
}

// 获取消息模块列表
export const messageModuleList = {
    url: `/${VERSION_DATA_CENTER}/homepage/message/module/list`,
}

// 获取我的消息列表
export const messageList = {
    url: `/${VERSION_DATA_CENTER}/homepage/my/message/list`,
    method: "POST",
}

// 获取我的待办数量
export const pendingNumber = {
    url: `/${VERSION_DATA_CENTER}/homepage/my/pending/number`,
}

// 获取我的待办筛选状态列表
export const workflowStatusList = {
    url: `/${VERSION_DATA_CENTER}/workflow/status/list`,
}

// 获取我的待办筛选模块列表
export const workflowModuleList = {
    url: `/${VERSION_DATA_CENTER}/workflow/module/list`,
}

// 待办列表
export const pendingList = {
    url: `/${VERSION_DATA_CENTER}/workflow/my/pending/list`,
    method: "POST",
}

// 一键已读未读信息
export const oneClickRead = {
    url: `/${VERSION_DATA_CENTER}/homepage/one/click/read`,
}


// 获取我的待办中待处理数量和抄送未读数量
export const workflowPendingInfo = {
    url: `/${VERSION_DATA_CENTER}/workflow/pending/info`,
}
